module.exports = __webpack_public_path__ + "static/img/loading.f00188b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/loading.svg
// module id = NZvF
// module chunks = 1